/**
 * @typedef {String} module:EventService.FeedbackCategoryEnum
 * @readonly
 * @description description
 * @property {String} od Object detection and everything not having to do with faces. "OD"
 * @property {String} fdfr Face detection and recognition specifically. "FDFR"
 */
const FeedbackCategoryEnum = Object.freeze({
    od: 'OD',
    fdfr: 'FDFR'
});

export default FeedbackCategoryEnum;
